





















import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import { RateChangesState, SetValuePayload } from "@/models";
import RateChangesModule from "@/store/modules/rate-changes";
import GeneralInfo from "@/views/rate-changes/components/GeneralInfo.vue";
import ApplyChanges from "@/views/rate-changes/partials/ApplyChanges.vue";
import SelectTenants from "@/views/rate-changes/partials/SelectTenants.vue";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "RateChange",
  components: { GeneralInfo, ApplyChanges, SelectTenants, ApplicationLayout }
})
export default class EditRateChange extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  @rateChanges.Action("getIPRCFormulas") private getIPRCFormulas!: () => void;
  @rateChanges.Action("setValue") private setValue!: (payload: SetValuePayload) => void;
  // ===== Clear Units ===== //
  private prepareSelectedUnits() {
    const preventResetStatuses = ["denied", "submitted_for_review"];
    if (!this.rateChanges.selectedUnits.every(unit => preventResetStatuses.includes(unit.status))) {
      this.setValue({ property: "selectedUnits", value: [] });
    }
  }
  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    this.getIPRCFormulas();
    this.prepareSelectedUnits();
  }
}
